import React, { useRef, useEffect } from "react";

/** Auto-resizing textarea */
const AutoTextarea: React.FC<React.TextareaHTMLAttributes<HTMLTextAreaElement>> = (props) => {
  const ref = useRef<HTMLTextAreaElement>(null);
  useEffect(() => {
    if (ref.current) {
      ref.current.style.height = "auto";
      ref.current.style.height = ref.current.scrollHeight + "px";
    }
  }, [props.value]);
  return <textarea ref={ref} {...props} />;
};

export default AutoTextarea;
